import { render, staticRenderFns } from "./Efooter.vue?vue&type=template&id=afe6e742&scoped=true"
import script from "./Efooter.vue?vue&type=script&lang=js"
export * from "./Efooter.vue?vue&type=script&lang=js"
import style0 from "./Efooter.vue?vue&type=style&index=0&id=afe6e742&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afe6e742",
  null
  
)

export default component.exports